import React from 'react';
import { lowerCase as _lowerCase } from "lodash";
import {Link, withRouter} from "react-router-dom";
import Logo from '../logo/logo';

class PrintableHeader extends React.PureComponent {  
  constructor(props) {
    super(props);
    this.state = {
      subDomain : null,
    }
  }
  
  render () {
      let { projectName, projectAmount } = this.props
    return(
    <div className="printable-header">
        <div className="header-info-container">
        <div className="printable-logo">
            <Logo/> 
        </div>
        <div>
            <p><b>Project Name: </b>{projectName}</p>
            <p><b>Project Amount: </b>{projectAmount}</p>
        </div>
        </div>
        </div>  
        )
  }
}
export default PrintableHeader;